import {eatalianoAxios} from "@/data/api/http/axios";
import {DayReport} from "@/data/entities/dayReport";

/**
 * Financial report of the restaurant over a period of days, `from` up to and
 * including `to` (`YYYY-MM-DD`, default: today): revenue (gross, net, VAT),
 * worked hours, order counts and the online payments to refund via Mollie.
 * Admins only.
 */
export const getDayReport = (restaurantId: number, from: string, to: string): Promise<DayReport> => (
    eatalianoAxios
        .get<DayReport>(`/admin/reports/${restaurantId}/day`, {params: {from, to}})
        .then(response => response.data)
);